import { FC } from 'react';
import { useNavigate, generatePath } from 'react-router';

import {
  Button,
  Icon,
  Stack,
  Typography,
} from '@data-products-and-ai/react-components';
import { MillwrightOutage } from '@/apis/millwrights/types/millwrightsApi';
import { OUTAGE_MILLWRIGHT_ROUTE } from '@/pages/Outages/routes';

import '@/pages/Millwrights/components/MillwrightOutages/MillwrightOutages.scss';

interface MillwrightOutagesProps {
  millwrightId: number;
  outages: MillwrightOutage[];
}

export const MillwrightOutages: FC<MillwrightOutagesProps> = ({
  outages,
  millwrightId,
}) => {
  const navigate = useNavigate();

  const handleNavigate = (outageId: number) => () => {
    if (!outageId) return;

    navigate(
      generatePath(OUTAGE_MILLWRIGHT_ROUTE, {
        outageId: outageId.toString(),
        millwrightId: millwrightId.toString(),
      }),
    );
  };

  return (
    <div className="millwright-outages">
      {outages.map((outage) => (
        <div className="millwright-outages__item" key={outage.outageId}>
          <Typography>{outage.outageId}</Typography>
          <Typography>{outage.outageName}</Typography>
          <div className="millwright-outages__item--navigation">
            <Button
              allCaps={false}
              type="primaryNoShadow"
              size="small"
              onClick={handleNavigate(outage.outageId)}
            >
              <Stack
                horizontalAlign="center"
                direction="row"
                gap={8}
                verticalAlign="center"
              >
                <Typography tag="textsmall">Check</Typography>
                <Icon
                  icon="IconCaretRight"
                  color="var(--color-white)"
                  iconSize={0.75}
                />
              </Stack>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
